import React from "react";
import { Box, Icon, type IconName } from "@salestrak/ui";

export { copyText, openHref } from "#app/lib/utils/copy-actions";

// stopPropagation: rows toggle their own reveal state on mobile, so the action
// click must not also fire the row click.
export function RowAction({
  icon,
  onClick,
}: {
  icon: IconName;
  onClick: () => void;
}) {
  return (
    <Box
      as="button"
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick();
      }}
      padding="2xs"
      rounded="sm"
      hoverBackground
      cursor="pointer"
    >
      <Icon name={icon} size="xs" color="muted" />
    </Box>
  );
}
